import _ from 'lodash'
import { providers, getNullApplicationNotifications } from '@adc/ui-adc'
import { UPDATE_PROPERTY_SAVE_STATE } from '../constants/actionTypes'
import {
  LISTING_CARD,
  MOBILE_LISTING_CARD,
  trackPropertySave,
} from '../services/analytics'
import { isMobile } from '../util/osDetector'

const { saveProperty, deleteSavedProperty } = providers.savePropertyProvider

const SAVE_MESSAGES = {
  save: authType => ({
    title:
      (authType === 'signup' ? 'Thank you for signing up. ' : '') +
      'Save Successful',
    message:
      'The property has been saved. Access all your saved properties on the User Dashboard.',
  }),
  unsave: () => ({
    title: 'Property Removed',
    message: 'The property is no longer saved on the User Dashboard.',
  }),
}

/* eslint-disable camelcase */
const updatePropertySaveState = (isSaved, property_id) => ({
  type: UPDATE_PROPERTY_SAVE_STATE,
  isSaved,
  property_id,
})

/**
 * This is pretty ugly but is temporary until we can use new infra to load full list of map pins and assets to have full synchronization.
 * @returns
 */
// Thunk Action Creator
export const toggleSave =
  ({
    listing,
    authType,
    updateListingSavedCallback = _.noop,
    notifications = getNullApplicationNotifications(),
    ...analyticsData
  }) =>
  async (dispatch, getState) => {
    const property_id = _.get(listing, 'primary_property.property_id')
    const is_currently_saved = _.get(
      listing,
      'primary_property.is_currently_saved'
    )

    const { assets } = getState()

    const currentPropertyAlreadySaved = assets.list.find(
      assetFromList =>
        _.get(assetFromList, 'primary_property.property_id') === property_id
    )?.primary_property?.is_currently_saved

    const isSaved = is_currently_saved || currentPropertyAlreadySaved

    /**
     * Handling the situation when the user is not logged in and tries to save an asset they've already saved.
     * Return here to avoid an extra call to save the asset after they log in.
     * Optimization: add notification that property is already saved so user sees why the heart turned red?
     */
    if (authType === 'login' && isSaved) {
      updateListingSavedCallback(isSaved) // should always be true but essentially it's just to update state of the selected listing in mobile map view
      return
    }

    // eslint-disable-next-line no-useless-catch
    try {
      const res = await (isSaved ? deleteSavedProperty : saveProperty)(
        property_id
      )

      dispatch(updatePropertySaveState(res.action === 'save', property_id))

      notifications.overlayBanner.open(SAVE_MESSAGES[res.action](authType))

      let triggeredFrom = LISTING_CARD
      if (isMobile()) {
        triggeredFrom = MOBILE_LISTING_CARD
      }

      trackPropertySave({
        listing,
        triggeredFrom,
        isSaved,
        ...analyticsData,
      })

      updateListingSavedCallback(res.action === 'save')
    } catch (err) {
      // TODO: implement pushVerificationQueueItem & requireVerification
      // currently, we don't have a message for user session expiration in graph
      // we will need to work on this when the graph starts supporting
      throw err
    }
  }
